// 自定义创建axios
import axios from "axios";

// axios 默认值
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'
axios.defaults.headers = { "Content-Type": "application/json;charset=UTF-8" };
axios.defaults.timeout = 30000;
// 自定义 axios配置
var Http = axios.create({
  withCredentials: false,
  headers: {
    "Content-Type": "application/json;charset=UTF-8"
  },
  baseURL: process.env.TEST_API
  // baseURL: 'http://localhost:8078'
});

// 请求时的拦截
Http.interceptors.request.use(
  config => {
    let token = localStorage.getItem("token");
    let url = config.url;
    //当前url非登录页面 需要设置请求token(调用广告接口时候放行))
    if (
      url.toLowerCase().indexOf("login") < 0 &&
      url.toLowerCase().indexOf("slideshow") < 0
    ) {
      if (token) {
        config.headers.token = `${token}`;
      } else {
        //如果非登录请求又没有token 则跳转到登录页面
        //自动跳转到企业微信授权首页
        window.location.href = process.env.QYWX_INDEX;
      }
    }
    return config;
  },
  function(error) {
    // 当请求异常时做一些处理
    return Promise.reject(error);
  }
);

// 响应时拦截
Http.interceptors.response.use(
  res => {
    // 返回响应时做一些处理
    if (res.data != undefined) {
      //响应中包含token
      if (res.data.data != undefined && res.data.data.token != undefined) {
        let token = res.data.data.token;
        localStorage.setItem("token", token.token);
      }
      //token失效了 需要重新登录
      if (res.data.status === 401 && res.data.message === "请先登录") {
        //自动跳转到企业微信授权首页
        localStorage.clear();
        //如果是通过消息点击进来 todo
        // let url = router.path;
        // //this.$toast.fail(redirect);
        // if (url.indexOf("dulivideo") >= 0) {
        //   localStorage.setItem("dulivideo", url);
        // }
        window.location.href = process.env.QYWX_INDEX;
      }
    }
    return res;
  },
  error => {
    if (error.response.status === 401) {
      // 401 说明 token 验证失败
      // 可以直接跳转到登录页面，重新登录获取 token
      // alert("网络异常")
      router.push("/login");
      return;
    } else if (error.response.status === 500) {
      // 服务器错误
      // do something
      return Promise.reject(error.response.data);
    }
    // 返回 response 里的错误信息
    return Promise.reject(error.response.data);
  }
);

export default Http;



//////////////////
// WEBPACK FOOTER
// ./common_function/http.js
// module id = null
// module chunks = 